import { registerPlugin, Capacitor } from '@capacitor/core';

const WaterNative = Capacitor.isNativePlatform() ? registerPlugin('Water') : null;

const KEY = 'spera_water';
const DEFAULT_GOAL = 2500;

function today() {
  return localDateKey(new Date());
}

function localDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function load() {
  try { return JSON.parse(localStorage.getItem(KEY) || '{}'); }
  catch { return {}; }
}

function save(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}

function dayData(all, date = today()) {
  return all[date] || { entries: [], goal: all._goal || DEFAULT_GOAL };
}

export function getDailyGoal() {
  return load()._goal || DEFAULT_GOAL;
}

export function setDailyGoal(goalMl) {
  const all = load();
  all._goal = goalMl;
  const t = today();
  if (all[t]) all[t].goal = goalMl;
  else all[t] = { entries: [], goal: goalMl };
  save(all);
  pushWidget(all);
}

export function getTodayLog() {
  return dayData(load());
}

export function getTotalToday() {
  return getTodayLog().entries.reduce((s, e) => s + e.amount, 0);
}

export function addWater(amountMl) {
  const all = load();
  const t = today();
  if (!all[t]) all[t] = { entries: [], goal: all._goal || DEFAULT_GOAL };
  all[t].entries.push({ amount: amountMl, time: new Date().toISOString() });
  save(all);
  pushWidget(all);
  return dayData(all);
}

export function removeWater(index) {
  const all = load();
  const t = today();
  if (all[t]) {
    all[t].entries.splice(index, 1);
    save(all);
    pushWidget(all);
  }
  return dayData(all);
}

export function getWeekHistory() {
  const all = load();
  const goal = all._goal || DEFAULT_GOAL;
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    const key = localDateKey(d);
    const data = all[key] || { entries: [], goal };
    const total = data.entries.reduce((s, e) => s + e.amount, 0);
    const label = i === 6 ? 'Today'
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
    return { key, label, total, goal: data.goal || goal };
  });
}

async function pushWidget(all) {
  if (!WaterNative) return;
  const t = today();
  const data = all[t] || { entries: [], goal: all._goal || DEFAULT_GOAL };
  const totalMl = data.entries.reduce((s, e) => s + e.amount, 0);
  const goalMl = data.goal || all._goal || DEFAULT_GOAL;
  try {
    await WaterNative.updateWidget({ totalMl, goalMl, date: t });
  } catch { /* widget update is non-critical */ }
}
